import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import {fetchCategories} from '../../api'
function AllCategories() {

    const [categories, setCategories] = useState([])

    useEffect(() => {
        async function getCategories() {
            const data = await fetchCategories()
            if (data?.length > 0) {
                setCategories(data)
            }
        }
        getCategories()
    }, [])

    return (
        <div>
            {categories?.map((category, index) => {
                console.log(category)
                return (
                    <div key={index} className="card card-body my-3">
                        <h2><Link to={`/categories/${category?.id}`}>{category?.name}</Link></h2>
                    </div>
                )
            })}
        </div>
    )
}
export default AllCategories